import RenderHTML from '../../ui-components/RenderHTML'
import { motion } from 'framer-motion'

type RadioBoxPropTypes = {
  iconUrl?: string
  text: string
  title?: string
  isSelected: boolean
}

export const RadioBox = ({ iconUrl, text, title, isSelected }: RadioBoxPropTypes) => {
  return (
    <motion.div
      className='border border-[#33A7E4] backdrop-blur-[27px] bg-white/3 rounded-2xl flex items-center px-5 py-4 w-full'
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
    >
      {iconUrl && (
        <div className='pr-5'>
          <img src={iconUrl} />
        </div>
      )}
      <div className='text-[#D1ECFF] text-[18px] font-[400] flex flex-1'>
        <div className='flex flex-col gap-1 text-left'>
          {title && <div className='text-white'>{title}</div>}
          {isSelected && (
            <motion.div
              initial={{ y: -10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.2, delay: 0.1 }}
              className='text-[#91D2FF] font-[400] text-[16px] max-w-[70%]'
            >
              {text}
            </motion.div>
          )}
        </div>
      </div>
      <div>
        <RenderHTML innerHTMLText={isSelected ? SelectedIcon : UnSelectedIcon} />
      </div>
    </motion.div>
  )
}

const SelectedIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <circle cx="10" cy="10" r="10" fill="white"/>
  <path d="M5.55469 10.5554L8.59913 13.3332L14.4436 6.6665" stroke="#127FD1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const UnSelectedIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <circle cx="10" cy="10.75" r="9.5" stroke="#87CFFF"/>
</svg>`
